import React from 'react';
import { Input } from 'antd';
import styled from 'styled-components';

const SearchStaffInput = ({ value, onChange, placeholder }: { value: string, onChange: (value: string) => void, placeholder: string }) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    return (
        <Container>
            <InputStyled
                bordered={false}
                value={value} onChange={handleChange} placeholder={placeholder} />
            <SearchBox>
                <SearchIcon />
            </SearchBox>
        </Container>
    );
};

export default SearchStaffInput;

const Container = styled.div`
    display: flex;
    align-self: stretch;
    align-items: center;
    height: 56px;
    gap: 10px;
    flex: 1 0 0;
    border-radius: 100px;
    border: 3px solid #2D6772;
    background: #FFF;
`;

const SearchBox = styled.div`
    display: flex;
    width: 56px;
    height: 56px;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;
    border-radius: 0 100px 100px 0;
    background: #2D6772;
`;

const InputStyled = styled(Input)`
    color: #1D2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

const SearchIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24C19.0751 24 24 19.0751 24 13C24 6.92487 19.0751 2 13 2ZM0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z" fill="white" />
        <path fillRule="evenodd" clipRule="evenodd" d="M20.3164 20.9406C20.7064 20.5496 21.3396 20.5488 21.7306 20.9388L26.4293 25.6253C26.8203 26.0153 26.8212 26.6485 26.4311 27.0395C26.0411 27.4306 25.408 27.4314 25.0169 27.0414L20.3182 22.3549C19.9272 21.9648 19.9264 21.3317 20.3164 20.9406Z" fill="white" />
    </svg>
);